/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registersubtitle1Inputs */

const en_registersubtitle1 = /** @type {(inputs: Registersubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You set up your profile and billing details after signing in.`)
};

const de_registersubtitle1 = /** @type {(inputs: Registersubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil und Rechnungsdaten richtest du nach der Anmeldung ein.`)
};

/**
* | output |
* | --- |
* | "You set up your profile and billing details after signing in." |
*
* @param {Registersubtitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const registersubtitle1 = /** @type {((inputs?: Registersubtitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registersubtitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_registersubtitle1(inputs)
	return de_registersubtitle1(inputs)
});
export { registersubtitle1 as "registerSubtitle" }